module.exports = __webpack_public_path__ + "img/accounting-coins-bill.ce40d529.svg";